// extracted by mini-css-extract-plugin
export default {"wrapper":"Environment_wrapper__D3UHw"};